import { render, staticRenderFns } from "./topic-filter.vue?vue&type=template&id=2a2e9800&scoped=true"
import script from "./topic-filter.vue?vue&type=script&lang=js"
export * from "./topic-filter.vue?vue&type=script&lang=js"
import style0 from "./topic-filter.vue?vue&type=style&index=0&id=2a2e9800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e9800",
  null
  
)

export default component.exports